import React, { useContext, useEffect, useRef, useState } from 'react';
import _ from 'lodash';
import { Dialog, DialogContent } from '@radix-ui/react-dialog';
import '@radix-ui/themes/styles.css';
import { useSelector, useDispatch } from 'react-redux';
import SocketContext from 'socket-context';
import { validateAndCreateSocketIfExist } from 'utils/SocketValidator';
import { socketMessageType } from 'types/Constants';

const enumBadgesType = {
  TEAM_PLAYER: 'Team Player',
  EXEMPLARY_LEADER: 'Exemplary Leader',
  TOP_CONTRIBUTOR: 'Top Contributor',
  BRILLIANT_EFFORT: 'Brilliant Effort',
  CREATIVE_THINKER: 'Creative Thinker',
  STAR_PARTICIPANT: 'Star Participant',
};

const InnerList = ({ items }: any) => {
  const [currentActiveIndex, setCurrentActiveIndex] = useState(0);
  const flatRef = useRef(null);
  const profileData = useSelector((state: any) => state?.auth?.user);

  const chunk = (arr, size) => {
    if (!arr || arr.length === 0) return [];
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };

  const onPrev = () => {
    if (currentActiveIndex !== 0) {
      const prevIndex = currentActiveIndex - 1;
      setCurrentActiveIndex(prevIndex);
      flatRef.current?.scrollTo({ left: prevIndex * flatRef.current.offsetWidth, behavior: 'smooth' });
    }
  };

  const onNext = () => {
    const chunks = chunk(items, 5);
    if (currentActiveIndex < chunks.length - 1) {
      const nextIndex = currentActiveIndex + 1;
      setCurrentActiveIndex(nextIndex);
      flatRef.current?.scrollTo({ left: nextIndex * flatRef.current.offsetWidth, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    console.log('currentActiveIndex ::: [...chunk(items, 5)]', currentActiveIndex, chunk(items, 5));
  }, [currentActiveIndex, items]);

  return (
    <div className="w-[48%] bg-[#DADFF1] pb-[1%]">
      <div className="flex justify-end -ml-[15px] bg-[#DADFF1]">
        <button className="p-[1%]" onClick={onPrev}>
          <div className="h-[10px] w-[10px]">
            <img
              src="/assets/arrowDown.png"
              alt="Previous"
              className="object-contain absolute top-[100px]"
              style={{ height: '2%', width: '4%' }}
            />
          </div>
        </button>
        <button className="p-[1%]" onClick={onNext}>
          <div>
            <img
              src="/assets/arrowDown.png"
              alt="Next"
              className="object-contain"
              style={{ height: '2%', width: '4%', transform: 'rotate(180deg)', top: '50px', marginTop: '-10px' }}
            />
          </div>
        </button>
      </div>

      <div
        ref={flatRef}
        className="h-full w-[75%] overflow-x-auto flex"
        style={{ scrollSnapType: 'x mandatory' }}
      >
        {chunk(items, 5).map((chunkItems, index) => (
          <div
            key={index}
            className="w-[40%] h-[10%] flex-shrink-0 flex flex-col justify-center items-center"
            style={{ scrollSnapAlign: 'start' }}
          >
            {chunkItems
              .filter((item, i, arr) => arr.findIndex((x) => x.senderName === item.senderName) === i)
              .map((v) => (
                <span
                  key={v.senderId}
                  className="text-[#212025] text-sm px-[2%]"
                  style={{ fontFamily: "'Lato', sans-serif" }}
                >
                  {v?.senderName || v?.userType?.toLowerCase()}
                </span>
              ))}
          </div>
        ))}
      </div>
    </div>
  );
};

const ReceivedBadgesModal = ({ visible, onRequestClose, onSwipeDown, onPressBack, session_id }: any) => {
  const dispatch = useDispatch();
  const socketHandler = useRef(null);
  const socketList = useContext(SocketContext);
  const [badgesData, setBadgesData] = useState([]);
  const profileData = useSelector((state: any) => state?.auth?.user);
  const sessionData = useSelector((state: any) => state?.live.settings?.sessionData);

  const initialBadgesData = [
    { id: 1, name: 'Team Player', senders: [] },
    { id: 2, name: 'Exemplary Leader', senders: [] },
    { id: 3, name: 'Top Contributor', senders: [] },
    { id: 4, name: 'Star Participant', senders: [] },
    { id: 5, name: 'Creative Thinker', senders: [] },
    { id: 6, name: 'Brilliant Effort', senders: [] },
  ];

  useEffect(() => {
    if (!socketHandler.current && sessionData?.id) {
      socketHandler.current = validateAndCreateSocketIfExist(sessionData?.id, handleOnMessage, socketList);
    }
    getReceivedBadges();
    dispatch({ type: 'RESET_NEW_BADGE_COUNT' });
  }, [sessionData?.id, visible, dispatch]);

  const getReceivedBadges = () => {
    console.log(sessionData?.id, profileData?.trainee_email, 'Check Mail');
    const data = {
      email: profileData?.trainee_email,
      sessionMapId: sessionData?.id,
    };
    // postDataWithToken(data, mobile_siteConfig.GET_BADGES)
    //   .then((res) => {
    //     if (res?.data?.getBadge && res?.data?.getBadge?.length > 0) {
    //       const _badgesData = [...initialBadgesData];
    //       res?.data?.getBadge?.forEach((element) => {
    //         const i = _badgesData.findIndex((e) => e.name === element?.achievementName);
    //         if (i !== -1) {
    //           _badgesData[i].senders = _.uniqBy([..._badgesData[i].senders, element], 'id');
    //         }
    //       });
    //       console.log(_badgesData, 'BadgesDataCheck');
    //       setBadgesData(_badgesData);
    //     }
    //   })
    //   .catch((error) => {
    //     console.log('save badges error -->', error);
    //   });
  };

  const parseToJson: any = (data: string) => {
    if (typeof data === typeof '') {
      try {
        return parseToJson(JSON.parse(data));
      } catch (err) {
        console.log('Error parsing JSON', data)
        return {}
      }
    } else {
      return data;
    }
  }

  const handleOnMessage = (msg) => {
    const data = parseToJson(msg);
    if (data?.type === socketMessageType.SHOW_BADGES) {
      getReceivedBadges();
    }
  };

  const renderBadges = (name) => {
    switch (name) {
      case enumBadgesType.TEAM_PLAYER:
        return (
          <div
            className="bg-cover bg-center"
            style={{ backgroundImage: `url(/assets/badges/teamPlayer.png)`, height: '25%', width: '20%' }}
          />
        );
      case enumBadgesType.EXEMPLARY_LEADER:
        return (
          <div
            className="bg-cover bg-center"
            style={{ backgroundImage: `url(/assets/badges/exemplaryLeader.png)`, height: '25%', width: '20%' }}
          />
        );
      case enumBadgesType.TOP_CONTRIBUTOR:
        return (
          <div
            className="bg-cover bg-center"
            style={{ backgroundImage: `url(/assets/badges/topContributor.png)`, height: '25%', width: '20%' }}
          />
        );
      case enumBadgesType.BRILLIANT_EFFORT:
        return (
          <div
            className="bg-cover bg-center"
            style={{ backgroundImage: `url(/assets/badges/brilliantEffort.png)`, height: '25%', width: '20%' }}
          />
        );
      case enumBadgesType.CREATIVE_THINKER:
        return (
          <div
            className="bg-cover bg-center"
            style={{ backgroundImage: `url(/assets/badges/creativeThinker.png)`, height: '25%', width: '20%' }}
          />
        );
      case enumBadgesType.STAR_PARTICIPANT:
        return (
          <div
            className="bg-cover bg-center"
            style={{ backgroundImage: `url(/assets/badges/starParticipant.png)`, height: '25%', width: '20%' }}
          />
        );
      default:
        return (
          <div
            className="bg-cover bg-center"
            style={{ backgroundImage: `url(/assets/badgeImage.png)`, height: '25%', width: '20%' }}
          />
        );
    }
  };

  const renderItem = ({ item }) => {
    if (item?.senders.length < 1) {
      return null;
    }
    return (
      <div className="h-[35%]">
        <div className="flex flex-row bg-white m-[1%] rounded-[4%] shadow-md overflow-hidden justify-between">
          <div className="flex flex-row items-center flex-1">
            <div className="bg-[#5B5D6B] rounded-[4%] overflow-hidden shadow-md px-[2%]">
              {renderBadges(item?.name)}
              <span className="text-[#5F488A] text-center text-base font-bold block pt-[-5%]" style={{ fontFamily: "'Lato', sans-serif" }}>
                Received
              </span>
              <span className="text-[#5F488A] text-center text-base font-bold block" style={{ fontFamily: "'Lato', sans-serif" }}>
                {item?.senders?.length}
              </span>
            </div>
          </div>
          <div className="border-l-4 border-[#E9BE50]" />
          <div>
            <span
              className="text-white text-sm bg-[#5F488A] h-[20%] text-center flex items-center justify-center italic"
              style={{ fontFamily: "'Lato', sans-serif" }}
            >
              Shared by
            </span>
            <InnerList items={item?.senders} />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="flex-1 bg-white" onMouseDown={onSwipeDown}>
      <Dialog open={visible} onOpenChange={onRequestClose}>
        <DialogContent className="h-[73%] bg-white w-full max-w-full overflow-y-auto">
          <button
            className="w-[20%] h-[0.6%] bg-gray-200 rounded-[1%] mx-auto mt-[1%]"
            onClick={() => dispatch({ type: 'RESET_NEW_BADGE_COUNT' })}
          />
          {badgesData?.filter((x) => x?.senders?.length > 0)?.length > 0 ? (
            <div className="p-[2%] flex-1">
              {badgesData.map((item, index) => (
                <React.Fragment key={item.id}>{renderItem({ item })}</React.Fragment>
              ))}
            </div>
          ) : (
            <div className="flex-1 flex justify-center items-center h-[60%]">
              <span>No badges received yet</span>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ReceivedBadgesModal;